import { useEffect, useState } from "react";
import { AdvancedOffer, DEFAULT_OFFER, loadAdvancedOffer } from "@/lib/advancedOffer";

/**
 * The first-month Advanced offer in the viewer's currency ("$7.99", "£7.99", "79 kr"), for
 * CTAs that name the price. USD until the pricing endpoint answers; one fetch per page load.
 */
const useAdvancedOffer = (enabled = true): AdvancedOffer => {
    const [offer, setOffer] = useState<AdvancedOffer>(DEFAULT_OFFER);
    useEffect(() => {
        if (!enabled) return;
        let cancelled = false;
        loadAdvancedOffer().then((o) => {
            if (!cancelled) setOffer(o);
        });
        return () => {
            cancelled = true;
        };
    }, [enabled]);
    return offer;
};

export default useAdvancedOffer;
